import * as React from 'react';

import Pagination from 'antd/es/pagination';

import { ItemsProvider, useItemsProviderContext, SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { BreadCrumbs } from '@common/react/components/UI/BreadCrumbs/BreadCrumbs';

import { Specialty } from '@commonTuna/react/objects/Specialty';

import SpecialtyTag from '@app/components/Pages/Specialties/SpecialtyTag';

import '@app/scss/pages/catalog.scss';

const SpecialtyList: React.FC = () => {
	const { state: { items, pagination }, actions: { handleChange } } = useItemsProviderContext<Specialty>();

	const onPaginationChange = (current, pageSize) => {
		handleChange({ page: current, pageSize });
	};

	return (<div className="catalog mb10">
		<ul className="catalog__list">
			{items.map((item) => <li key={item.id} className="catalog__list__item">
				<SpecialtyTag specialty={item} />
			</li>)}
		</ul>
		{pagination?.total > items.length && <div className="pull-right mt10 mb10">
			<Pagination onChange={onPaginationChange} {...pagination} />
		</div>}
	</div>);
};

const Specialties: React.FC = () => {
	return <>
		<ServerPageProvider
			path="specialties"
			defaultTitle="Specialties"
			inner={(page) => (
				<ItemsProvider<Specialty>
					rows={page?.items}
					loadRequest="specialtyPortalPageViewListRemote"
					filters={{ column: [{ caption: 'name', direction: SortingDirection.Ascending }] }}
					paginationUrl={{ defaultPageSize: 200 }}
					withHandleUrl
				>
					<div className="container">
						<BreadCrumbs
							title="Specialties"
						/>
						<div className="site-headline site-headline_with-button clearfix">
							<h1 className="pull-left">Specialties</h1>
						</div>
						<SpecialtyList />
					</div>
				</ItemsProvider>
			)}
		/>
	</>;
};

export default Specialties;
